<template>
  <!-- 单独一张图片情况 -->
  <!-- v-if="imageUrl && showDeleteIcon" -->

  <div class="alone-box">
    <EnlargeImg v-if="imageUrl" :imgSrc="imageUrl" class="avatar" />
    <img
      :src="closeImg"
      v-if="imageUrl"
      class="_close el-icon-error"
      @click.stop="deleteUploadHandle(0)"
    />
    <p class="success_upload__tip" v-if="imageUrl && fileTitle" style="width: 320px;">
      <span :title="fileTitle">{{ fileTitle }}</span>
    </p>
    <div class="progress-box" v-if="isProgress">
      <!-- 上传中··· -->
      <div class="progress-item">
        <el-progress
          type="circle"
          :width="50"
          :show-text="true"
          :stroke-width="4"
          :percentage="uploadPercent"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AloneBox',
  data() {
    return {}
  },
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    closeImg: {
      type: String,
      default: '',
    },
    isProgress: {
      type: Boolean,
      default: false,
    },
    uploadPercent: {
      type: Number,
      default: 0,
    },
    fileTitle: {
      type: String,
      default: '',
    },
  },
  methods: {
    deleteUploadHandle(index) {
      this.$emit('deleteUploadHandle', index)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.success_upload__tip{
  font-size: 14px;
  color: #969799;
  margin-top: 90px;
}
</style>
